import watch   from "redux-watch";
import isEqual from 'is-equal';
import ControllerBase   from './controller_base';
import { api } from 'apps/api';
import {
  COMMENT_CLICK_REPLY,
} from 'apps/events';
export default class ReplyController extends ControllerBase{
  constructor(tag) {
    super(tag);
    this.customEvent(COMMENT_CLICK_REPLY, (e) => { this.onClickReply(e) });
  }
  onClickReply(e){
    let newValue = {
      forms_comments_reply: {
        inputs: {
          parent_id: {
            value: e.detail
          }
        }
      }
    }
    this.dispatchNewValue(newValue);
  }
}
